import { parsePhoneNumber } from "libphonenumber-js";
import dialCodes from "../config/dialCodes";

export const getPhoneNumberDetails = (
  phoneNumber,
  dialCode,
  country,
  isoCode
) => {
  let phoneDetails = { nationalNumber: phoneNumber };
  try {
    if (!isoCode) {
      if (dialCode) {
        isoCode = dialCodes.find((e) => e.dialCode === dialCode)?.isoCode;
      }

      if (country) {
        isoCode = dialCodes.find((e) => e.name === country)?.isoCode;
      }
    }

    phoneDetails = parsePhoneNumber(phoneNumber, isoCode || "IN");
  } catch (e) {
    console.log(e);
  }

  return phoneDetails;
};